(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["category-block"] && !window.DesignMode) return;
  try {
    
$(document).ready(function() {
 $('body:not(.rtl) .ttproduct_categories_wrap').owlCarousel({             
            nav : true,
            dots : false,
            autoplay:true,
            loop: false,
            responsive: {
            100: {
              items: 1
            },
            481: {
              items: 2
            },
			767: {
              items: 2
            },
            992: {
              items: 3
            },
            1201: {
              items: 3
            }
          }
          });
        $('body.rtl .ttproduct_categories_wrap').owlCarousel({
            nav : true,
            rtl:true,
            loop: true,
            autoplay:true,
            dots : false,
            responsive: {
            100: {
              items: 1
            },
            481: {
              items: 2
            },
			767: {
              items: 2
            },
            992: {
              items: 3
            },
            1201: {
              items: 3
            }
          }
          });

    if(jQuery(".ttproduct_categories_wrap .owl-nav").hasClass('disabled')){
     jQuery(".ttproduct-category .customNavigation").hide();
    }else{
     jQuery(".ttproduct-category .customNavigation").show();
    }
       jQuery(".ttproduct-category .customNavigation .next").click(function(){
        jQuery('.ttproduct-category .ttproduct_categories_wrap').trigger('next.owl');
      });
      jQuery(".ttproduct-category .customNavigation .prev").click(function(){
        jQuery('.ttproduct-category .ttproduct_categories_wrap').trigger('prev.owl');
      }); 
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-model-2"]) return;
  try {
    
$(document).ready(function() {
 $('body:not(.rtl) #tt-megamenu .list_product_menu_content').owlCarousel({
              items : 3, //1 items above 1000px browser width
              nav : true,
    		  autoPlay:true,
              autoplaySpeed:1000,
              stopOnHover: false,
              loop: false,
              dots : true,
              responsive: {
                      768: {
                        items: 3
                      },
                      481: {
                        items: 2
                      },
                      100: {
                        items: 1
                      }
                    }
          });
 $('body.rtl #tt-megamenu .list_product_menu_content').owlCarousel({
            items : 3, //1 items above 1000px browser width
            nav : true,
            autoPlay:true,
            autoplaySpeed:1000,
            rtl: true,
            stopOnHover: false,
            loop: false,
            dots : true,
            responsive: {
                      768: {
                        items: 3
                      },
                      481: {
                        items: 2
                      },
                      100: {
                        items: 1
                      }
                    }
          });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-model-3"] && !window.DesignMode) return;
  try {
    
$(document).ready(function() {
 $('body:not(.rtl) #tt-megamenu .list_product_menu_content').owlCarousel({
              items : 3, //1 items above 1000px browser width
              nav : true,
    		  autoPlay:true,
              autoplaySpeed:1000,
              stopOnHover: false,
              loop: false,
              dots : true,
              responsive: {
                      992: {
                        items: 3
                      },
                      481: {
                        items: 2
                      },
                      100: {
                        items: 1
                      }
                    }
          });
 $('body.rtl #tt-megamenu .list_product_menu_content').owlCarousel({
            items : 3, //1 items above 1000px browser width
            nav : true,
            autoPlay:true,
            autoplaySpeed:1000,
            rtl: true,
            stopOnHover: false,
            loop: false,
            dots : true,
            responsive: {
                      992: {
                        items: 3
                      },
                      481: {
                        items: 2
                      },
                      100: {
                        items: 1
                      }
                    }
          });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook-products"] && !window.DesignMode) return;
  try {
    
$(document).ready(function() {
 $('body:not(.rtl) .tt-lookbook-wrap .lookbook_wrap').owlCarousel({
              items : 1, //1 items above 1000px browser width
              nav : true,
			autoplay:true,
loop: true,
              dots : false,

            responsive: {
                      1279: {
                        items: 1
                      },
                      1250: {
                        items: 1
                      },
                      600: {
                        items: 1
                      }
                    }
          });
 $('body.rtl .tt-lookbook-wrap .lookbook_wrap').owlCarousel({
              items : 1, //1 items above 1000px browser width
              nav : true,
              rtl: true,
			autoplay:true,
loop: true,
              dots : false,
            responsive: {
                      1279: {
                        items: 1
                      },
                      1250: {
                        items: 1
                      },
                      600: {
                        items: 1
                      }
                    }
          });
       if(jQuery(".lookbook_wrap .owl-nav").hasClass('disabled')){
           jQuery(".tt-lookbook-wrap .customNavigation").hide();
          }else{
           jQuery(".tt-lookbook-wrap .customNavigation").show();
          }
       jQuery(".tt-lookbook-wrap .customNavigation .next").click(function(){
        jQuery('.tt-lookbook-wrap .lookbook_wrap').trigger('next.owl');
      });
      jQuery(".tt-lookbook-wrap .customNavigation .prev").click(function(){
        jQuery('.tt-lookbook-wrap .lookbook_wrap').trigger('prev.owl');
      }); 
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-category"]) return;
  try {
    
$(document).ready(function(){
$(".dt-menu-expand").click(function(event){
event.preventDefault();
if( $(this).hasClass("dt-mean-clicked") ){
$(this).text("+");
if( $(this).prev('ul').length ) {
$(this).prev('ul').slideUp(400);
} else {
$(this).prev('.megamenu-child-container').find('ul:first').slideUp(600);
}
} else {
$(this).text("-");
if( $(this).prev('ul').length ) {
$(this).prev('ul').slideDown(400);
} else{
$(this).prev('.megamenu-child-container').find('ul:first').slideDown(2000);
}
}

$(this).toggleClass("dt-mean-clicked");
return false;
});

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-section"] && !window.DesignMode) return;
  try {
    
$(document).ready(function() {
 $('body:not(.rtl) .tt-testimonial-wrap .testimonials_wrap').owlCarousel({
              items : 1, //1 items above 1000px browser width
              nav : false,
              dots : true,			
				loop:true,
			  autoplay:true,
              autoplayHoverPause:true,
            responsive: {
                      1279: {
                        items: 1
                      },
                      1250: {
                        items: 1
                      },
                      600: {
                        items: 1
                      }
                    }
          });
 $('body.rtl .tt-testimonial-wrap .testimonials_wrap').owlCarousel({
              items : 1, //1 items above 1000px browser width
              nav : false,
              rtl: true,
              dots : true,
			  autoplay:true,
				loop:true,
              autoplayHoverPause:true,
            responsive: {
                      1279: {
                        items: 1
                      },
                      1250: {
                        items: 1
                      },
                      600: {
                        items: 1
                      }
                    }
          });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["TT-mega_menu"] && !window.DesignMode) return;
  try {
    
$(document).ready(function() {
 $('body:not(.rtl) #tt-megamenu .list_product_menu_content').owlCarousel({
              items : 3, //1 items above 1000px browser width
              nav : true,
    		  autoPlay:true,
              autoplaySpeed:1000,
              stopOnHover: false,
              loop: false,
              dots : true,
              responsive: {
                      992: {
                        items: 3
                      },
                      481: {
                        items: 2
                      },
                      100: {
                        items: 1
                      }
                    }
          });
 $('body.rtl #tt-megamenu .list_product_menu_content').owlCarousel({
            items : 3, //1 items above 1000px browser width
            nav : true,
            autoPlay:true,
            autoplaySpeed:1000,
            rtl: true,
            stopOnHover: false,
            loop: false,
            dots : true,
            responsive: {
                      992: {
                        items: 3
                      },
                      481: {
                        items: 2
                      },
                      100: {
                        items: 1
                      }
                    }
          });
});

  } catch(e) { console.error(e); }
})();

})();
